import type { VisualField } from '../../../types/wizardTypes';

/**
 * Rendering/validation category a field's type falls into - shared by the
 * MSSQL-specific SQL types and the generic types so FieldCard and
 * fieldSchemaConverter don't need to special-case every literal.
 */
export type FieldKind = 'string' | 'number' | 'integer' | 'boolean' | 'date' | 'datetime' | 'enum' | 'image';

const KIND_BY_TYPE: Record<VisualField['type'], FieldKind> = {
  string: 'string',
  number: 'number',
  integer: 'integer',
  boolean: 'boolean',
  enum: 'enum',
  date: 'date',
  image: 'image',
  varchar: 'string',
  nvarchar: 'string',
  text: 'string',
  uniqueidentifier: 'string',
  int: 'integer',
  bigint: 'integer',
  smallint: 'integer',
  tinyint: 'integer',
  decimal: 'number',
  float: 'number',
  bit: 'boolean',
  datetime: 'datetime',
  datetime2: 'datetime',
};

export function getFieldKind(type: VisualField['type']): FieldKind {
  return KIND_BY_TYPE[type] ?? 'string';
}
